
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';

const GoogleLogo = ({ className }: { className?: string }) => (
    <svg viewBox="0 0 24 24" className={className} xmlns="http://www.w3.org/2000/svg">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
    </svg>
);

const XLogo = ({ className }: { className?: string }) => (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className}>
        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
);

interface SocialAuthProps {
    onConnect: (provider: string) => void;
    isLoading?: boolean;
}

export const SocialAuth: React.FC<SocialAuthProps> = ({ onConnect, isLoading }) => {
    return (
        <div className="grid grid-cols-2 gap-3">
            <button
                onClick={() => onConnect('GOOGLE')}
                disabled={isLoading}
                className="flex items-center justify-center gap-2 p-3 rounded-md border border-stone-200 hover:bg-stone-50 transition-colors disabled:opacity-50 group bg-white shadow-sm"
            >
                <GoogleLogo className="w-5 h-5 group-hover:scale-110 transition-transform" />
                <span className="text-xs font-bold text-stone-600">Google</span>
            </button>
            <button
                onClick={() => onConnect('TWITTER')}
                disabled={isLoading}
                className="flex items-center justify-center gap-2 p-3 rounded-md border border-stone-200 hover:bg-stone-50 transition-colors disabled:opacity-50 group bg-white shadow-sm"
            >
                <XLogo className="w-4 h-4 text-stone-900 group-hover:scale-110 transition-transform" />
                <span className="text-xs font-bold text-stone-600">X</span>
            </button>
        </div>
    );
};
